// Builds an Emergent-ready prompt that bundles the idea, tech stack,
// features, project structure and ALL generated code files.
export const generateEmergentPrompt = (currentIdea, currentScaffold, allGeneratedCode) => {
  if (!currentIdea) return '';

  const suggestions = currentIdea.ai_suggestions;
  const techStack = suggestions?.tech_stack;
  const mvpScope = suggestions?.mvp_scope || [];
  const suggestedFeatures = suggestions?.suggested_features || [];

  let prompt = `# ${currentIdea.name}\n\n`;
  prompt += `## Project Description\n${currentIdea.description}\n\n`;

  if (techStack) {
    prompt += `## Tech Stack\n`;
    prompt += `- Frontend: ${techStack.frontend}\n`;
    prompt += `- Backend: ${techStack.backend}\n`;
    prompt += `- Database: ${techStack.database}\n\n`;
  }

  if (mvpScope.length > 0) {
    prompt += `## MVP Features\n`;
    mvpScope.forEach((feature, idx) => {
      prompt += `${idx + 1}. ${feature}\n`;
    });
    prompt += '\n';
  }

  if (suggestedFeatures.length > 0) {
    prompt += `## Additional Features\n`;
    suggestedFeatures.slice(0, 5).forEach((feature) => {
      prompt += `- **${feature.title}**: ${feature.description}\n`;
    });
    prompt += '\n';
  }

  // Include project structure if available
  if (currentScaffold?.scaffold?.project_structure) {
    prompt += `## Project Structure\n\`\`\`\n`;
    currentScaffold.scaffold.project_structure.forEach((item) => {
      prompt += `${item.type === 'folder' ? '📁' : '📄'} ${item.path}\n`;
    });
    prompt += `\`\`\`\n\n`;
  }

  // Include ALL generated code
  if (allGeneratedCode.length > 0) {
    prompt += `## Generated Code Files\n\n`;
    prompt += `Use the following code as the starting point for each file:\n\n`;

    allGeneratedCode.forEach((codeItem, idx) => {
      prompt += `### File ${idx + 1}: ${codeItem.filename}\n`;
      if (codeItem.explanation) {
        prompt += `> ${codeItem.explanation}\n\n`;
      }
      prompt += `\`\`\`${codeItem.language || 'javascript'}\n`;
      prompt += codeItem.code;
      prompt += `\n\`\`\`\n\n`;
    });
  }

  prompt += `## Implementation Instructions\n`;
  prompt += `1. Create the project structure as shown above\n`;
  prompt += `2. Implement each file using the provided code as starting points\n`;
  prompt += `3. Connect the frontend to backend API endpoints\n`;
  prompt += `4. Add user authentication\n`;
  prompt += `5. Style with modern, responsive design\n`;
  prompt += `6. Add proper error handling throughout\n`;

  return prompt.trim();
};
